import { useState } from "react";
import { CircularProgress } from "@mui/material";

import Card from "./card";
import PrimaryButton from "./primary-button";
import { UTILITY_STEPS, formatMoney } from "./utilities-config";

export default function PowerReview({ offer, method, onMethod, onBack, onConfirm, isSubmitting }) {
  const [isConfirmingCard, setIsConfirmingCard] = useState(false);
  const earn = method === "stake" ? offer.powerCashBack : offer.powerCardCashBack;
  // Picking the card costs cash back, so ask once before switching to it.
  const selectMethod = (key) => {
    if (key === "card" && method !== "card") setIsConfirmingCard(true);
    else onMethod(key);
  };
  return (
    <>
      <Card
        steps={UTILITY_STEPS}
        activeStep={0}
        progress={70}
        wide
        onBack={onBack}
        footer={
          <>
            <PrimaryButton onClick={onConfirm} disabled={isSubmitting}>
              Submit order {isSubmitting ? <CircularProgress size={16} sx={{ color: "inherit" }} /> : null}
            </PrimaryButton>
            <p className="su-legal">
              By submitting, you agree to Public Grid’s Terms, Privacy Policy and Limited Power of Attorney. Stake shares your name, address, move-in date and SSN with Public Grid.
            </p>
          </>
        }
      >
        <h2 className="su-title">Review the details</h2>
        <p className="su-subtitle">100% renewable energy, powered by Public Grid.</p>
        <h3 className="su-label">Your plan</h3>
        <div className="su-panel">
          <div className="su-panel-block">
            <span className="su-eyebrow">Price per kWh</span>
            <strong className="su-big">
              {offer.pricePerKwh}¢<small> /kWh</small>
            </strong>
            <span className="su-note">at 1,000 kWh</span>
          </div>
          <div className="su-panel-block">
            <span className="su-eyebrow">Service starts</span>
            <strong className="su-big">Move-in day</strong>
            <span className="su-note">Your move-in date</span>
          </div>
        </div>
        <h3 className="su-label">Payment</h3>
        <div className="su-panel">
          <div className="su-methods">
            {[
              { key: "stake", title: "Stake Account", body: "Opened just now", amount: offer.powerCashBack },
              { key: "card", title: "Your card", body: "Debit card or bank", amount: offer.powerCardCashBack },
            ].map((option) => (
              <button
                key={option.key}
                type="button"
                className={`su-method${method === option.key ? " is-selected" : ""}`}
                aria-pressed={method === option.key}
                onClick={() => selectMethod(option.key)}
              >
                <span className="su-radio" aria-hidden="true" />
                <span className="su-method-copy">
                  <strong>{option.title}</strong>
                  <small>{option.body}</small>
                </span>
                <b>+{formatMoney(option.amount)}</b>
              </button>
            ))}
          </div>
          <div className="su-panel-line">
            <span>Due today</span>
            <strong>$0</strong>
          </div>
          <div className="su-panel-line">
            <strong>You earn</strong>
            <span className="su-earn">
              <b>{formatMoney(earn)} Cash Back</b>
              <small>after your first bill</small>
            </span>
          </div>
        </div>
        <p className="su-fineprint">
          No charge today. We never pull more than your balance. Early termination may result in a fee of {formatMoney(offer.earlyTerminationFee)}
        </p>
      </Card>
      {isConfirmingCard ? (
        <div className="su-sheet-backdrop" role="dialog" aria-modal="true" aria-labelledby="su-sheet-title" onClick={() => setIsConfirmingCard(false)}>
          <div className="su-sheet" onClick={(event) => event.stopPropagation()}>
            <h3 id="su-sheet-title">Pay with your card instead?</h3>
            <p>
              Your cash back drops from {formatMoney(offer.powerCashBack)} to {formatMoney(offer.powerCardCashBack)}. The {formatMoney(offer.powerCashBack)} is
              only paid to a Stake account.
            </p>
            <div className="su-sheet-compare">
              <div>
                <small>Stake Account</small>
                <b className="is-accent">+{formatMoney(offer.powerCashBack)}</b>
              </div>
              <div>
                <small>Your card</small>
                <b>+{formatMoney(offer.powerCardCashBack)}</b>
              </div>
            </div>
            <PrimaryButton onClick={() => setIsConfirmingCard(false)}>Setup Stake and earn {formatMoney(offer.powerCashBack)}</PrimaryButton>
            <PrimaryButton
              variant="danger"
              onClick={() => {
                onMethod("card");
                setIsConfirmingCard(false);
              }}
            >
              Use my card and earn {formatMoney(offer.powerCardCashBack)}
            </PrimaryButton>
          </div>
        </div>
      ) : null}
    </>
  );
}
